import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=796e2be3&"
import script from "./SidebarComponent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SidebarComponent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports